<aside
  class="relative flex h-full min-h-0 flex-col overflow-hidden rounded-[32px] bg-lGray900 transition-all duration-300"
  [ngClass]="isOpen ? 'w-[22rem] shrink-0 p-5 lg:w-[26rem]' : 'w-20 shrink-0 p-3'"
>
  <l-sidebar-module-selector
    [modules]="modules"
    [selectedModuleId]="selectedModuleId"
    [isOpen]="isOpen"
    [isDropdownOpen]="isModuleDropdownOpen"
    [fallbackTitle]="title"
    (menuToggled)="toggleMenu()"
    (dropdownToggled)="toggleModuleDropdown($event)"
    (dropdownClosed)="closeModuleDropdown()"
    (moduleSelected)="onModuleSelected($event)"
  ></l-sidebar-module-selector>

  @if (isOpen) {
    <hr class="mt-4 border-lGray700" />
  }
  
  <div class="mt-4 flex items-center gap-3" [class.pt-12]="!isOpen">
    <div class="scale-90">
      <l-progress-ring [progress]="progress" />
    </div>

    @if(isOpen) {
      <p class="text-base font-medium text-lWhite">{{ title }}</p>
    }
  </div>

  <div class="mt-4 min-h-0 flex-1 overflow-y-auto pr-1" [class.mt-6]="!isOpen">
    @for (lesson of lessons; track lesson.id; let isLast = $last; let index = $index) {
      <l-sidebar-lesson-item
        [lesson]="lesson"
        [isLast]="isLast"
        [isOpen]="isOpen"
        [isSelected]="lesson.id === selectedLessonId"
        [canAccess]="canAccessLesson(index)"
        (lessonSelected)="onLessonClick(lesson, index)"
      ></l-sidebar-lesson-item>
    }
  </div>

  <hr class="my-4 border-lGray700" />

  <div class="space-y-4">
    @if (hasAssessment) {
      <div
        class="flex items-center"
        [ngClass]="[
          isOpen ? 'justify-between gap-3' : 'justify-center',
          canAccessAssessment() ? 'cursor-pointer' : 'cursor-not-allowed opacity-60'
        ]"
        (click)="onAssessmentClick()"
      >
        <div class="flex items-center gap-3">
          <span class="grid h-7 w-7 place-items-center rounded-full bg-lGray700">
            <l-icon
              class="bg-gradient-to-b from-lYellow100 to-lYellow500 bg-clip-text text-sm text-transparent"
              [filled]="true"
            >grade</l-icon>
          </span>
          @if (isOpen) {
            <p class="text-base text-lSecondary">Avaliação</p>
          }
        </div>
        @if (isOpen) {
          <p class="text-sm text-lSecondary">{{ scoreText }}</p>
        }
      </div>
    }

    <div
      class="flex items-center"
      [ngClass]="[(isOpen ? 'justify-between gap-3' : 'justify-center'), canAccessCertificate() ? 'cursor-pointer' : 'cursor-not-allowed opacity-60']"
      (click)="onCertificateClick()"
    >
      <div class="flex items-center gap-3">
        <l-icon
          class="block h-7 w-7"
          [src]="canAccessCertificate() ? 'assets/icons/medal-active.svg' : 'assets/icons/medal-inactive.svg'"
        ></l-icon>
        @if (isOpen) {
          <p class="text-base" [ngClass]="canAccessCertificate() ? 'text-lPrimary' : 'text-lSecondary'">Certificado</p>
        }
      </div>

      @if (isOpen && canAccessCertificate()) {
        <button
          type="button"
          class="grid h-8 w-8 place-items-center rounded-lg text-lSecondary transition-colors duration-150 hover:bg-lGray850/80 hover:text-lWhite"
          (click)="onCertificateDownloadClick($event)"
          aria-label="Baixar certificado"
        >
          <l-icon class="text-2xl">download</l-icon>
        </button>
      } @else if (isOpen) {
        <div class="h-8 w-8"></div>
      }
    </div>
  </div>
</aside>
